var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"dummy","fluid":"","tag":"section"}})}
var staticRenderFns = []

export { render, staticRenderFns }